// Centralized image assets for ROADRIG. All real founder + brand imagery.
export const IMG = {
  // Individual founder photos
  RIDE_COAST:
    "https://customer-assets.emergentagent.com/job_premium-gear-12/artifacts/zs4t29xx_WhatsApp%20Image%202026-06-29%20at%2001.31.56.jpeg",
  GREECE_SKETCH:
    "https://customer-assets.emergentagent.com/job_premium-gear-12/artifacts/8ukrxfv2_WhatsApp%20Image%202026-06-29%20at%2001.31.55%20%282%29.jpeg",
  FOUNDER_SMILE:
    "https://customer-assets.emergentagent.com/job_premium-gear-12/artifacts/9nxpawdk_ROADRIG%20FOUNDER%20JOHN%20CHRISTOPHER.png",
  FOUNDER_PORTRAIT:
    "https://customer-assets.emergentagent.com/job_premium-gear-12/artifacts/komol9cl_John%20Christopher%20Founder%20ROADRIG..jpeg",
  HARLEY_FRONT:
    "https://customer-assets.emergentagent.com/job_premium-gear-12/artifacts/p3zu0y1w_John%20Christopher%20Founder%20ROADRIG%20Harley%20davidson%20Road%20Glide%203.jpeg",
  HARLEY_REAR:
    "https://customer-assets.emergentagent.com/job_premium-gear-12/artifacts/888waio1_John%20Christopher%20Founder%20ROADRIG%20Harley%20davidson%20Road%20Glide%203..jpeg",

  // Family — behind every mile
  WIFE_BEE:
    "https://customer-assets.emergentagent.com/job_premium-gear-12/artifacts/twgknyef_ROADRIG%20FOUNDER%20WIFE%20BEE.jpg",
  LOLA:
    "https://customer-assets.emergentagent.com/job_premium-gear-12/artifacts/qpbelgr5_20241011_002145000_iOS.jpg",

  // Real product / engineering imagery
  INTERIOR_LOGO:
    "https://customer-assets.emergentagent.com/job_premium-gear-12/artifacts/ym7lcgi6_ROADRIG%20Outlaw%20Woven%20Interior%20LogoV2.png",
  TECH_PACK:
    "https://customer-assets.emergentagent.com/job_premium-gear-12/artifacts/8xmguo04_06_ROADRIG_OUTLAW_V1_TECH_PACK.jpg",

  // Real motion + freshly-extracted stills
  BIKE_OUTSIDE_SUN: "/media/bike-outside-sun.jpg",
  VIDEO_BIKE_TEST: "/media/bike-test.mp4",
  LONG_RIDE: "/media/long-ride.jpg",
  FRUSTRATION_JOHN: "/media/frustration-john.jpg",

  // V5 assets — founder portrait, garage-wall sketches, campaign character
  FOUNDER_SMILE_V2: "/media/founder-smile.jpg",
  SKETCH_BOARD: "/media/sketch-board.jpg",
  SKETCH_TECHPACK_PAGE: "/media/sketch-techpack-page.jpg",
  SKETCH_BENCH: "/media/sketch-bench.jpg",
  CHARACTER_SEA: "/media/character-sea.jpg",
  STORY_PANELS: "/media/story-panels.jpg",
  JOURNEY_POSTER_V2: "/media/journey-poster-v2.jpg",
  CAMPAIGN_GRID: "/media/campaign-grid.jpg",
  BIKE_WATERFRONT: "/media/bike-waterfront.jpg",
  BUCKLE_MACRO: "/media/buckle-macro.jpg",
  ZIPPER_MACRO: "/media/zipper-macro.jpg",
  VIDEO_STORY: "/media/story-v2.mp4",
  VIDEO_STORY_POSTER: "/media/story-v2-poster.jpg",
};
